import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom"; // Using react-router to get user ID from URL
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "../utils/Loading";
// import { getRoleDisplay } from "../utils/getRoleDisplay";
import { USERS_BASE_URL } from "../services/SignUpService";
import { getRoleDisplay } from "../utils/getRoleDisplay";

export const UpdateUser = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const [user, setUser] = useState({
    photo: "",
    firstName: "",
    lastName: "",
    email: "",
    role: [],
    isAdmin: "",
    isVerified: "",
    createdAt: "",
  });

  const { id } = useParams();
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${USERS_BASE_URL}/api/users/list/${id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch user data");
        }
        const data = await response.json();
        setUser(data);
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };
    fetchUserData();
  }, [id]);

  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setUser((prevUser) => ({
  //     ...prevUser,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };
  const handleChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    if (type === "checkbox") {
      setUser((prevUser) => ({
        ...prevUser,
        [name]: checked,
      }));
    } else if (name === "role") {
      // Handle multiple select options
      const selectedRoles = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);

      setUser((prevUser) => ({
        ...prevUser,
        role: selectedRoles, // Store all selected roles
      }));
    } else {
      setUser((prevUser) => ({
        ...prevUser,
        [name]: value,
      }));
    }
  };

  const updateUser = async () => {
    try {
      setLoading(true);
      const response = await axios.put(
        `${USERS_BASE_URL}/api/users/list/update/${id}`,
        {
          ...user,
          role: user.role, // Ensure selected roles are sent to the API
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      Swal.fire({
        position: "top-center",
        icon: "success",
        title: "Success",
        text: "User updated successfully!",
        showConfirmButton: false,
        timer: 2500,
      });

      console.log(response.data);
      navigate(`/api/dashboard/user-profile/${user._id}`);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Something went wrong. Unable to update user!";

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Unable to update user! | ${errorMessage}`,
        footer: '<a href="/">Why do I have this issue?</a>',
      });

      console.error("Error updating user:", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // const updateUser = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.put(
  //       `${USERS_BASE_URL}/api/users/list/update/${id}`,
  //       user,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     Swal.fire({
  //       position: "top-center",
  //       icon: "success",
  //       title: "Success",
  //       text: "User updated successfully!",
  //       showConfirmButton: false,
  //       timer: 2500,
  //     });
  //     console.log(response.data);
  //     navigate(`/api/dashboard/user-profile/${user._id}`);
  //   } catch (error) {
  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "Something went wrong. Unable to update user!";

  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: `Unable to update user! | ${errorMessage}`,
  //       footer: '<a href="/">Why do I have this issue?</a>',
  //     });

  //     console.error("Error updating user:", errorMessage);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  if (loading) {
    return (
      <div className="text-center">
        <Loading />
      </div>
    );
  }

  if (error) {
    return <div className="alert alert-danger">{error.message}</div>;
  }

  if (!user) {
    return (
      <div className="text-center">
        <p>No user found!</p>
      </div>
    );
  }

  return (
    <section className="profile">
      <h1 className="bg-white p-3">
        User Profile <hr />
      </h1>

      <div className="container mt-4 mb-4">
        <div className="row">
          <div className="col-md-4">
            <div className="card text-center">
              <div className="card-body">
                <img
                  src={user.avatar || "https://via.placeholder.com/150"}
                  alt="User Profile"
                  className="rounded-circle mb-3"
                  style={{ width: "100px", height: "100px" }}
                />
                <h5>
                  {user.firstName} {user.lastName.slice(0, 1)}.
                </h5>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card text-muted">
              <div className="card-header">
                <p className="card-title">
                  {user.firstName} {user.lastName} | Profile Account Details
                </p>
                <hr />
                <div className="float-end p-2">
                  <b>Admin: &nbsp; </b>
                  {user.isAdmin ? (
                    <>
                      <i
                        className="fa fa-unlock-alt text-success"
                        aria-hidden="true"
                      ></i>{" "}
                      &nbsp;
                      <div className="btn btn-outline-success btn-sm">YES</div>
                    </>
                  ) : (
                    <>
                      <i
                        className="fa fa-lock text-danger"
                        aria-hidden="true"
                      ></i>
                      &nbsp; &nbsp;
                      <div className="btn btn-outline-danger btn-sm">NO</div>
                    </>
                  )}
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <b>Verified: &nbsp; </b>
                  {user.isVerified ? (
                    <>
                      <i
                        className="fa fa-check-square text-success"
                        aria-hidden="true"
                      ></i>{" "}
                      <div className="btn btn-outline-success btn-sm">YES</div>
                    </>
                  ) : (
                    <>
                      <i
                        className="fa fa-ban text-danger"
                        aria-hidden="true"
                      ></i>{" "}
                      <div className="btn btn-outline-danger btn-sm">NO</div>
                    </>
                  )}
                </div>
              </div>

              <div className="card-body">
                <div className="cart-text">
                  <h5>First Name</h5>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control text-uppercase me-2"
                      placeholder="First Name"
                      name="firstName"
                      value={user.firstName || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <h5>Last Name</h5>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control text-uppercase me-2"
                      placeholder="Last Name"
                      name="lastName"
                      value={user.lastName || ""}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Email */}
                  <h5>Email Address</h5>
                  <div className="input-group mb-3">
                    <input
                      type="text"
                      className="form-control text-uppercase me-2"
                      placeholder="Email address"
                      name="email"
                      value={user.email || ""}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Role */}
                  <h5>Role</h5>
                  {/*  // value={user.role ? user.role : "Normal User"} */}
                  <div className="input-group mb-3">
                    <select
                      multiple
                      className="form-select form-select-lg mb-3"
                      id="sel2"
                      name="role"
                      // value={getRoleDisplay(user) || ""}
                      value={user.role} // Ensure the selected values are reflected
                      onChange={handleChange}
                    >
                      <option disabled>Please select a role</option>
                      <option value="Admin">Admin</option>
                      <option value="SuperAdmin">Super Admin</option>
                      <option value="Manager">Manager</option>
                      <option value="Developer">Developer</option>
                      <option value="Normal User">Normal User</option>
                      required
                    </select>
                  </div>

                  {/*Isverified  */}
                  {user && !user.isVerified && (
                    <>
                      <h5>Is user account verified?</h5>
                      <small className="mb-4">Please select one option</small>
                      <div className="d-flex align-items-center">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isVerified"
                            id="isVerifiedNo"
                            checked={user.isVerified === false}
                            onChange={() =>
                              setUser((prev) => ({
                                ...prev,
                                isVerified: false,
                              }))
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="isVerifiedNo"
                          >
                            NO
                          </label>
                        </div>
                        <div className="form-check ms-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isVerified"
                            id="isVerifiedYes"
                            checked={user.isVerified === true}
                            onChange={() =>
                              setUser((prev) => ({
                                ...prev,
                                isVerified: true,
                              }))
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="isVerifiedYes"
                          >
                            YES
                          </label>
                        </div>
                      </div>
                    </>
                  )}

                  {/* isAdmin */}
                  {user && !user.isAdmin && !user.SuperAdmin && (
                    <>
                      <h5>Does user has admin prevelages?</h5>
                      <small className="mb-4">Please select one option</small>
                      <div className="d-flex align-items-center">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isAdmin"
                            id="isAdminNo"
                            checked={user.isAdmin === false}
                            onChange={() =>
                              setUser((prev) => ({ ...prev, isAdmin: false }))
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="isAdminNo"
                          >
                            NO
                          </label>
                        </div>
                        <div className="form-check ms-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="isAdmin"
                            id="isAdminYes"
                            checked={user.isAdmin === true}
                            onChange={() =>
                              setUser((prev) => ({ ...prev, isAdmin: true }))
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="isAdminYes"
                          >
                            YES
                          </label>
                        </div>
                      </div>
                    </>
                  )}

                  <hr />
                  <div className="d-flex align-items-center">
                    {/* Joined */}
                    <p className="card-text text-muted mb-0 mt-4 me-3">
                      <strong>Joined:</strong>{" "}
                      {user.createdAt
                        ? new Date(user.createdAt).toLocaleDateString()
                        : ""}
                    </p>

                    {/* Modify */}
                    <div className="mb-0 mt-4 me-3">
                      <strong>Modify:</strong>{" "}
                      <input
                        type="date"
                        name="updatedAt"
                        id="updatedAt"
                        className="form-control d-inline-block"
                        style={{ width: "auto" }}
                        onChange={(e) =>
                          setUser((prev) => ({
                            ...prev,
                            updatedAt: e.target.value,
                          }))
                        }
                      />
                    </div>

                    {/* Conditionally render "UpdatedAt" only if updatedAt is set */}
                    {user.updatedAt && (
                      <p className="card-text text-muted mb-0 mt-4">
                        <strong>Updated at:</strong>{" "}
                        {new Date(user.updatedAt).toLocaleDateString()}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex mt-4 mb-4">
              {/* Back */}
              <Link
                to="/api/dashboard/users"
                className="btn btn-outline-dark btn-lg me-4"
                title="Edit"
              >
                <i className="fa fa-chevron-left"></i> BACK
              </Link>

              {/* Update button */}
              <button
                className="btn btn-outline-info btn-lg me-4"
                title="Update"
                onClick={updateUser}
              >
                <i className="fa fa-wrench"></i> UPDATE
              </button>
              <Link
                to={`/api/dashboard/user-profile/${user._id}`}
                className="btn btn-outline-danger btn-lg"
              >
                <i className="fa fa-ban"></i> CANCEL
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
